/**
 * Converts markdown content to Slack formatting
 */
export function convertMarkdownToSlack(markdown: string | undefined | null): string {
    if (!markdown) {
        return "";
    }

    return (
        markdown
            // Convert markdown lists to Slack bullet points
            .replace(/^- (.*$)/gim, "• $1")
            .replace(/^\* (.*$)/gim, "• $1")
            // Convert numbered lists to Slack format
            .replace(/^(\d+)\. (.*$)/gim, "$1. $2")
            // Convert bold text **text** to *text*
            .replace(/\*\*(.*?)\*\*/g, "*$1*")
            // Convert headers to bold
            .replace(/^### (.*$)/gim, "*$1*")
            .replace(/^## (.*$)/gim, "*$1*")
            .replace(/^# (.*$)/gim, "*$1*")
            .trim()
    );
}
